import React from "react";
import Images from "../../assets/images/Images";
import styled from "styled-components";

const HomeChildrenDiv = styled.div`
    flex-direction: row;
    display: flex;
    height: 100%;
    justify-content: flex-end;
    align-items: flex-end;
    padding-bottom: 40px;
    padding-right: 20px;
    background-color: white;
`;

const HomeChildrenComponent: React.FC = () => (
    <HomeChildrenDiv>
        <img src={Images.logoMapfre} alt="Logo" style={{height: 20, marginRight: 20}}/>
    </HomeChildrenDiv>
);

export default HomeChildrenComponent;
